"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var createHandlerSetter_1 = __importDefault(require("../factory/createHandlerSetter"));
var safeHasOwnProperty_1 = __importDefault(require("../shared/safeHasOwnProperty"));
var useEvent = function useEvent(ref, eventName, options) {
  var _a = (0, createHandlerSetter_1["default"])(),
    handler = _a[0],
    setHandler = _a[1];
  if (!!ref && !(0, safeHasOwnProperty_1["default"])(ref, 'current')) {
    throw new Error('Unable to assign any scroll event to the given ref');
  }
  (0, react_1.useEffect)(function () {
    // @ts-ignore
    var cb = function cb(event) {
      if (handler.current) {
        handler.current(event);
      }
    };
    if (ref.current && ref.current.addEventListener && handler.current) {
      ref.current.addEventListener(eventName, cb, options);
    }
    return function () {
      if (ref.current && ref.current.addEventListener && handler.current) {
        ref.current.removeEventListener(eventName, cb, options);
      }
    };
  }, [eventName, ref.current, options]);
  return setHandler;
};
exports["default"] = useEvent;